/* eslint-disable */
/**
 * Product Gallery Slider
 */
;(function ($) {
  $( document ).ready(function() {
    $('.woocommerce-product-gallery__wrapper').flexslider({
      animation: 'slide',
      animationLoop: false,
      slideshow: false,
      selector: '.alena-gallery-wrapper > div',
      smoothHeight: true,
      controlNav: false,
      slideshow: false,
      animationSpeed: 500,
      initDelay: 100,
      allowOneSlide:false,
      sync: '.alena-gallery-thumbs-wrapper',
      start: function() {
        const flexwrappers = document.querySelectorAll('.flex-viewport');
        // solves flexslider bug that sets first image height to 0.
        if (flexwrappers[0]) {
          console.log('flexslider loaded'); // action needed to fire below setAttributes.
          flexwrappers[0].setAttribute('style', 'height: auto; position: relative; overflow: hidden;');
          const height = $('.flex-active-slide > a > img').height();
          if (height && 0 !== height) {
            flexwrappers[0].setAttribute('style', 'height: ' + height + 'px; position: relative; overflow: hidden;');
          }
        }
      },
    });

    $('.alena-gallery-thumbs-wrapper').flexslider({
      animation: 'slide',
      controlNav: false,
      animationLoop: false,
      slideshow: false,
      selector: '.alena-gallery-thumbs > div',
      itemWidth: 100,
      itemMargin: 5,
      asNavFor: '.woocommerce-product-gallery__wrapper'
    });
  });
})(jQuery);
